module.exports = __webpack_public_path__ + "img/Down.7ec80f7c.svg";